import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFolderCase(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3a3 3 0 0 1 3 3v1h6a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H4v9a1 1 0 0 0 1 1h6a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5Zm7.06 10a1 1 0 0 1 .707.293l1.92 1.92a1 1 0 0 1 0 1.415l-.822.822 1.842 1.843a1 1 0 1 1-1.414 1.414l-1.843-1.842-.822.823a1 1 0 0 1-1.414 0l-1.921-1.921a1 1 0 0 1 0-1.415l3.06-3.059.073-.066A1 1 0 0 1 17.06 13Zm-1.646 4.06.506.505.823-.822.822-.823-.505-.506-1.646 1.646ZM5 5a1 1 0 0 0-1 1v1h7V6a1 1 0 0 0-1-1H5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFolderCase)
